import type { ConsentPolicyKey } from '@wix/thunderbolt-symbols';

export const consentPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_HtmlComponent',
  componentNameDefault: 'Html Component',
};

export const DEFAULT_CONSENT_POLICY: ConsentPolicyKey = 'essential';
